var map = {
	"./en/card_3_2.png": "0Snn",
	"./es/card_3_2.png": "Y1Kd",
	"./pt/card_3_2.png": "bS7f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05JQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_3_2\.png$
// module id = 05JQ
// module chunks = 0